import * as _ from 'lodash';
import { X_TOKEN, LOGIN_URL } from '../constants/action-types';

const headers = () => {
  const xToken = localStorage.getItem(X_TOKEN);
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'authorization': `Bearer ${xToken}`
  }
};

const isValidToken = () => {
  const xToken = localStorage.getItem(X_TOKEN);
  return !!xToken;
}

const defaultResponse = async (res) => {
  const status = res.status;
  res = await res.json();
  if (status === 403) {
    localStorage.removeItem(X_TOKEN);
    window.location.href = LOGIN_URL;
  } else if (status >= 400) {
    const message = res.message;
    return { resStatus: status, message: message }
  } else {
    return { ...res, resStatus: status }
  }
}

const get = (api, token) => {
  // if(shouldBeAuth && !isValidToken())  {
  //   return null;
  // }
  let status = 200;
  return fetch(api, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token,
    },
    // credentials: 'include',
    method: 'GET'
  })
    .then((res) => defaultResponse(res));
};

const post = (api, data, shouldBeLoggedIn = true) => {
  //   if(shouldBeLoggedIn && !isValidToken())  {
  //     return null;
  //   }
  return fetch(api, {
    headers: {
      'Authorization': data.token || '',
      'Content-Type': 'application/json',
    },
    // credentials: 'include',
    method: 'POST',
    body:  delete data.token && JSON.stringify(data)
  })
    .then((res) => defaultResponse(res));
};

const put = (api, data, shouldBeLoggedIn = true) => {
  if (shouldBeLoggedIn && !isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'PUT',
    body: JSON.stringify(data)
  })
    .then((res) => defaultResponse(res));
};

const destroy = (api) => {
  if (!isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'DELETE'
  })
    .then((res) => defaultResponse(res));
};

const toggle = (api) => {
  if (!isValidToken()) {
    return null;
  }
  return fetch(api, {
    headers: headers(),
    credentials: 'include',
    method: 'PUT'
  })
    .then((res) => defaultResponse(res));
};

export {
  headers,
  get,
  post,
  put,
  destroy,
  toggle
};